export const DEFAULT_GLUE = ' · '
